<template>
  <v-data-table
    :headers="headers"
    :items="dados.linhas"
    :items-per-page="isUmaUnidade ? -1 : 10"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    :disable-pagination="isUmaUnidade"
    :hide-default-footer="isUmaUnidade"
    class="elevation-0"
  >
    <!-- ordenar por e pesquisar -->
    <template v-slot:top>
      <v-row class="mb-2">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              {{ titulo }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>

      <!-- ordenar por -->
      <v-row v-if="!isUmaUnidade">
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>

        <v-col
          cols="0"
          md="4"
        />

        <!-- pesquisar -->
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- média CDS -->
    <template v-slot:[`item.mediaCds`]="{ item }">{{ item.mediaCds | decimal }}</template>

    <!-- desvio padrão CDS -->
    <template v-slot:[`item.desvioPadraoCds`]="{ item }">{{ item.desvioPadraoCds | decimal }}</template>

    <!-- total de quantidades -->
    <template
      v-if="!isUmaUnidade"
      v-slot:[`body.append`]
    >
      <tr>
        <td class="text-center" colspan="2">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td class="text-center">
          <strong>{{ dados.total.nServidoresNaoAtende }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ dados.total.nServidoresEmDesenvolvimento }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ dados.total.nServidoresAtende }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ dados.total.mediaCds | decimal }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ dados.total.desvioPadraoCds | decimal }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaResultadosCDS',

  components: { AppSort, AppSearch },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    isUmaUnidade: {
      type: Boolean,
      required: true,
    },
    dados: {
      type: Object,
      required: true,
      default: () => ({
        linhas: [],
        total: [],
      }),
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'NOME DA UNIDADE',
          value: 'unidade.nome',
          width: '34%',
          sortable: false,
        },
        {
          text: 'SIGLA DA UNIDADE',
          value: 'unidade.sigla',
          width: '10%',
          align: 'center',
        },
        {
          text: 'TOTAL DE SERVIDORES COM CDS NÃO ATENDE',
          value: 'nServidoresNaoAtende',
          width: '12%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'TOTAL DE SERVIDORES COM CDS EM DESENVOLVIMENTO',
          value: 'nServidoresEmDesenvolvimento',
          width: '12%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'TOTAL DE SERVIDORES COM CDS ATENDE',
          value: 'nServidoresAtende',
          width: '12%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'MÉDIA CDS DA UNIDADE',
          value: 'mediaCds',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'DESVIO PADRÃO CDS DA UNIDADE',
          value: 'desvioPadraoCds',
          width: '10%',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'unidade.nome',
        selecionado: { id: 'unidade.nome', descricao: 'Nome da Unidade' },
        lista: [
          { id: 'unidade.nome', descricao: 'Nome da Unidade' },
          { id: 'unidade.sigla', descricao: 'Sigla da Unidade' },
          { id: 'nServidoresNaoAtende', descricao: 'Total de Servidores com CDS Não Atende' },
          { id: 'nServidoresEmDesenvolvimento', descricao: 'Total de Servidores com CDS Em Desenvolvimento' },
          { id: 'nServidoresAtende', descricao: 'Total de Servidores com CDS Atende' },
          { id: 'mediaCds', descricao: 'Média CDS da Unidade' },
          { id: 'desvioPadraoCds', descricao: 'Desvio Padrão CDS da Unidade' },
        ],
      },
    };
  },
};
</script>
